import { render, staticRenderFns } from "./StatisticAssistenceCalendar.vue?vue&type=template&id=581a7a8c"
import script from "./StatisticAssistenceCalendar.vue?vue&type=script&lang=js"
export * from "./StatisticAssistenceCalendar.vue?vue&type=script&lang=js"
import style0 from "./StatisticAssistenceCalendar.vue?vue&type=style&index=0&id=581a7a8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports